module.exports = __webpack_public_path__ + "img/block_default_02.6387fc51.png";